module.exports = __webpack_public_path__ + "static/media/webmotors-alpha.49cc4444.png";